<div style="padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ddd;" class="recommendation-item">
  <a href="/recommendation/{recommendation.id}" 
        style="width:100%;">
    <div style="margin-bottom: 5px;" class="recommendation-item-text">
      <span><Button style="display:inline-block; padding: 0;"
      onClick={() => handleRecommendationBookmark(recommendation.id)}><i class="icon f7-icons">{recommendation.bookmark ? 'bookmark_fill' : 'bookmark'}</i></Button>
      </span>
    {@html fBoldText(recommendation.title, ':', '--')}
    </div>
    <div style="display:flex; justify-content: space-between;">
      <div style="width: 24%">
        <Button large small class="recommendation-item-btn"
          style="background-color:#c8f3f0;"
          href="/recommendation/{recommendation.id}"
          routeProps={{recommendation}} reloadDetail={true}>Recommendation</Button>
      </div>
      <div style="width: 24%">
        {#if recommendation.generalRecommendation && recommendation.generalRecommendation.clinical} 
        <Button large small class="recommendation-item-btn"
              style="background-color:#dcdcdc;"
              onClick={() => handlePopup('clinical', 'Clinical Summary', recommendation)}>Summary</Button>
        {/if}
      </div>
      <div style="width: 24%">
        {#if recommendation.riskText}
          <Button large small class="recommendation-item-btn"
            style="background-color:#f8d39a;"
            onClick={() => handlePopup('risk', 'Risk Factor', recommendation)}>Risk Factor</Button>
        {/if}
      </div>
      <div style="width: 24%">
        {#if recommendation.servFreq}
          <Button large small class="recommendation-item-btn"
          style="background-color:#bed1f9;"
          onClick={() => handlePopup('service', 'Frequency of Service', recommendation)}>Freq. of Service</Button>
        {/if}
      </div>
    </div>
  </a>
</div>
<script>
  import {
    f7,
    Button,
  } from 'framework7-svelte';
  import { fBoldText } from '../utils.js';
  import { onDestroy } from 'svelte';
  import { arrBookmarkedRec } from '../stores.js';

  $:isSavedBookmark;

  export let generalRec;
  export let recommendation;
  let popupOpened = false;
  let popup;
  let isSavedBookmark = recommendation.bookmark;
  let arrBookmarkedRecommendations;

  const unsubscribeBookmarkData = arrBookmarkedRec.subscribe(arr => {
    arrBookmarkedRecommendations = arr;
    isSavedBookmark = recommendation.bookmark;
  });
  onDestroy(unsubscribeBookmarkData);

  function handleRecommendationBookmark(id) {
    // add bookmark value to recommendation obj
    const index = arrBookmarkedRecommendations.indexOf(id);

    if (!recommendation.bookmark && index < 0) {
      // not currently saved
      arrBookmarkedRecommendations.push(id);
      recommendation.bookmark = true;
    } 

    // deselect
    if (recommendation.bookmark && index > -1) {
      arrBookmarkedRecommendations.splice(index, 1);
      recommendation.bookmark = false;
    }
    arrBookmarkedRec.set(arrBookmarkedRecommendations);
    localStorage.setItem("bookmarked", JSON.stringify(arrBookmarkedRecommendations));
  }

  function handlePopup(id, title, rec) {
    let content = '';
    if (id === 'clinical') {
      content = `<iframe width="100%" height="100%" src="https://www.uspreventiveservicestaskforce.org/prevent/clinicalsummary/${generalRec.uspstfAlias}"></iframe>`;
    } else if (id === 'service') {
      content = rec.servFreq;
      content = `<div class="block">
                <div class="card">
                  <div class="card-content card-content-padding">
                    ${content}
                  </div>
                </div>
              </div>`;
    } else if (id === 'risk') {
      content += `<h4>Risk Factor: ${rec.riskName}</h4>`;
      content += rec.riskText;
      content = `<div class="block">
                <div class="card">
                  <div class="card-content card-content-padding">
                    ${content}
                  </div>
                </div>
              </div>`;
    }
    // Create popup
    popup = f7.popup.create({
      backdrop: false,
      content: `
        <div class="popup popup-${id} popup-tablet-fullscreen">
          <div class="page">
            <div class="navbar">
              <div class="navbar-bg"></div>
              <div class="navbar-inner">
                <div class="title">${title} - ${rec.title}</div>
                <div class="right">
                  <a href="#" class="link popup-close nav-link">
                    <i class="icon f7-icons">multiply</i>
                  </a>
                </div>
              </div>
            </div>
            <div class="page-content">
              ${content}
            </div>
          </div>
        </div>
      `.trim(),
    });
    
    // Open it
    popup.open();
  }

  </script>
<style>
.uspstf-btn.clinical {
  background-color: #dcdcdc !important;
}
</style>